import { render, staticRenderFns } from "./event_edit.vue?vue&type=template&id=532b2e40&"
import script from "./event_edit.vue?vue&type=script&lang=js&"
export * from "./event_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports